import {LOGIN,LOGOUT} from './../Actions/Types'

const initialState={
    newUserData:{awda:"dawd"}
}
export  default  function (state = 0,action) {
    switch (action.type) {
        case LOGIN:
            return {
                ...state,
                newUserData:action.payload
            }
        default:
            return state
    }
}